import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Header = styled.header`
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  gap: 32px;
  align-items: center;
  background-size: cover;
  padding: 0;
  display: block;
  justify-content: start;
  display: flex;

  ${breakpoint("tablet")`
    justify-content: start;
    padding: 24px 32px 12px 32px;
  `}
`
